export default "__VITE_ASSET__BBtZhpwY__"